import { Component, Inject } from '@angular/core';
import { BZG_MODAL_DATA, BzgModalRef } from 'bz-genome-angular';

@Component({
  selector: 'biz-view-differences-modal',
  templateUrl: './view-differences-modal.component.html',
  styleUrls: ['./view-differences-modal.component.scss']
})
export class ViewDifferencesModalComponent {
  dataCompare: { originalModel: { language: string; code: string }, modifiedModel: { language: string; code: string } };
  isLoadingDiff: boolean = true;
  options = {
    scrollBeyondLastLine: false,
    readOnly: true,
    wordWrap: 'on',
    lineNumbers: 'on',
    minimap: { enabled: true },  
    diffCodeLens: true,  
    automaticLayout: true 
  };
  
  constructor(
    @Inject(BZG_MODAL_DATA) public data: { item: any },
    public modalComponentRef: BzgModalRef
  ) {
    const originalRaw = this.data?.item?.oldContent ?? '';
    const modifiedRaw = this.data?.item?.newContent ?? '';
    const toPrettyString = (val: unknown) => {
      if (typeof val === 'string') {
        const trimmed = val.trim();
        try {
          const parsed = JSON.parse(trimmed);
          return JSON.stringify(parsed, null, 2).replace(/\r\n/g, '\n');
        } catch {
          return trimmed.replace(/\r\n/g, '\n');
        }
      }
      return JSON.stringify(val, null, 2).replace(/\r\n/g, '\n');
    };
    const originalStr = toPrettyString(originalRaw);
    const modifiedStr = toPrettyString(modifiedRaw);
    this.dataCompare = {
      originalModel: { language: 'json', code: originalStr },
      modifiedModel: { language: 'json', code: modifiedStr }
    };
  }

  close() {
    this.modalComponentRef.close();
  }

  onDiffInit(_: any) {
    // When Monaco diff editor initializes, hide loading
    this.isLoadingDiff = false;
  }
}
